import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@/shared/ui';

import { useLogout } from './api';

export function LogoutButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logout = useLogout();
  return (
    <Button
      variant="ghost"
      size="sm"
      disabled={logout.isPending}
      onClick={() => {
        logout.mutate(undefined, { onSettled: () => void navigate('/login', { replace: true }) });
      }}
    >
      {t('auth.logout')}
    </Button>
  );
}
